import styled from 'styled-components';

import { sizing } from '@/styles/theme';

const Fieldset = styled.fieldset`
  font-size: ${sizing.fontSize.sm};
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export { Fieldset };
